<div style="height: 98dvh; display: flex; justify-content: space-between; flex-direction: column">
  <div>
    <app-additional-action-header [title]="locale.currentTranslation.dataPrivacy"/>
    <div class="base-content-container">
      <div style="display: flex; flex-direction: column; gap: 16px; font-family: Inter">
        <div>
          <h2>Datenschutzerklärung</h2>
        </div>
        <div>
          <h2>Zielgruppe dieses Datenschutzhinweises</h2>
          Dieser Datenschutzhinweis richtet sich an alle Personen, die die FNOL-Webanwendung nutzen oder besuchen,
          insbesondere:

          <ul>
            <li>
              <b>Fahrzeugnutzer:innen</b><br>
              (z. B. Fahrer:innen eines durch den Mobilitätsanbieter versicherten e-Scooters)
            </li>
            <li>
              <b>Geschädigte Personen</b><br>
              (z. B. Beteiligte an einem Unfall, die selbst keinen e-Scooter genutzt haben)
            </li>
            <li>
              <b> Weitere beteiligte Dritte</b><br>
              (z. B. Zeug:innen)
            </li>
            <li>
              <b>Besucher:innen der Website</b><br>
              (auch ohne aktive Schadenmeldung)
            </li>
          </ul>
        </div>
        <div>
          <h2>1. Verantwortlicher</h2>
          <div>Verantwortlicher im Sinne der DSGVO ist:
            <div style="display: flex; flex-direction: column; gap: 8px; margin-top: 8px;">
              <div><b>KLRM GmbH</b></div>
              <div>Voigstraße 34</div>
              <div>Germany</div>
              <div>Vertreten durch: Achim Lenz</div>
              <div>E-Mail: <a href="mailto:kontakt@klrm.berlin">kontakt&#64;klrm.berlin</a></div>
            </div>
            <div>
              <h2>2. Zweck der Datenverarbeitung</h2>
              Die Verarbeitung erfolgt zur Nutzung der FNOL-Webanwendung sowie zur Bearbeitung und Regulierung von
              Versicherungsfällen. Dies umfasst insbesondere:<br>
              <ul>
                <li>Technische Bereitstellung der Seite</li>
                <li>Bearbeitung und Prüfung von Schadensmeldungen</li>
                <li>Kommunikation mit Versicherungspartnern</li>
                <li>Geltendmachung oder Abwehr von Ansprüchen</li>
                <li>Rückfragen im Rahmen der Schadenabwicklung</li>
              </ul>
            </div>
            <div>
              <h2>3. Rechtsgrundlagen der Verarbeitung</h2>

              Die Verarbeitung personenbezogener Daten erfolgt insbesondere auf Grundlage von:
              <ul>
                <li><b>Art. 6 Abs. 1 lit. a DSGVO</b> – Einwilligung (z. B. bei Cookies)</li>
                <li><b>Art. 6 Abs. 1 lit. b DSGVO</b> – Vertragserfüllung (z. B. durch Fahrer:innen im Schadenfall)</li>
                <li><b>Art. 6 Abs. 1 lit. f DSGVO</b> – berechtigtes Interesse (z. B. bei geschädigten Dritten, zur
                  IT-Sicherheit)
                </li>
                <li><b>Art. 9 Abs. 2 lit. f DSGVO</b> – Verarbeitung besonderer Kategorien personenbezogener Daten
                  (z. B.
                  Gesundheitsdaten im Schadenfall)
                </li>
                <li><b>§ 31 und § 213 VVG</b> – Verarbeitung im Rahmen der Leistungsprüfung durch den Versicherer</li>
                <li><b>§ 147 AO und § 257 HGB</b> – gesetzliche Aufbewahrungspflichten (z. B. bis zu 10 Jahre)</li>
              </ul>
            </div>
            <div>
              <h2>4. Logfiles und technische Zugriffsdaten</h2>
              Beim Aufruf der Schadenmeldeseite werden automatisch folgende technische Daten erhoben und temporär
              gespeichert:
              <ul>
                <li>IP-Adresse</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Aufgerufene Seiten / Dateien</li>
                <li>Browsertyp und Version</li>
                <li>Betriebssystem</li>
                <li>Referrer-URL</li>
                <li>Übertragene Datenmenge</li>
              </ul>
              Diese Daten dienen der technischen Bereitstellung, der Sicherheit des Systems und der Fehleranalyse. Die
              Speicherung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
            </div>
            <div>
              <h2>5. Cookies und eingesetzte Tools</h2>
              Die FNOL-Anwendung verwendet Cookies und kann Tools von Drittanbietern nutzen. Diese dienen z. B. der
              Webanalyse, der Verbesserung der Nutzerfreundlichkeit oder der Systemsicherheit.
            </div>
            <div>
              <h2>6. Kategorien verarbeiteter Daten</h2>
              Je nach Nutzung und Rolle können folgende Datenarten verarbeitet werden:
              <ul>
                <li>Kontaktdaten (Name, E-Mail, Telefonnummer)</li>
                <li>Unfall-/Schadendaten (Ort, Zeit, Hergang, Beteiligte)</li>
                <li>Versicherungsinformationen, Fahrzeugdaten</li>
                <li>Ggf. Gesundheitsdaten (z. B. bei Personenschäden)</li>
                <li>Kommunikationsdaten (z. B. E-Mail-Verkehr)</li>
                <li>Technische Zugriffsdaten (siehe oben)</li>
                <li>Ggf. Angaben zu Zeug:innen oder weiteren Beteiligten</li>
              </ul>
            </div>
            <div>
              <h2>7. Empfänger und eingesetzte Dienstleister</h2>
              Personenbezogene Daten können an folgende Empfänger übermittelt werden:
              <ul>
                <li>Versicherungspartner (z. B. Signal Iduna)</li>
                <li>Beauftragte Dienstleister (z. B. IT-Provider, Gutachter, Reparaturpartner)</li>
                <li>Behörden, sofern gesetzlich erforderlich</li>
              </ul>
            </div>
            <div>
              <h2>8. Speicherdauer</h2>
              Daten werden nur so lange gespeichert, wie dies für den jeweiligen Zweck erforderlich ist oder gesetzlich
              vorgeschrieben ist. Typische Fristen ergeben sich aus:
              <ul>
                <li> Steuer- und handelsrechtlichen Vorschriften (§ 147 AO, § 257 HGB) → 6–10 Jahre</li>
                <li>Versicherungsrechtlichen Vorgaben (§ 31 VVG)</li>
                <li>Verjährungsfristen zivilrechtlicher Ansprüche (i. d. R. 3 Jahre)</li>
              </ul>
            </div>
            <div>
              <h2>9. Kommunikation und Benachrichtigungen</h2>
              Im Zuge der Schadenbearbeitung kann es notwendig sein, dich per E-Mail oder telefonisch zu kontaktieren.
              Die
              Kontaktaufnahme erfolgt:
              <ul>
                <li>Zur Klärung des Sachverhalts</li>
                <li>Zur Rückmeldung über den Bearbeitungsstand</li>
                <li>Zur Anforderung fehlender Informationen</li>
              </ul>
              Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b und f DSGVO. Es werden keine Werbe-E-Mails
              versendet.
            </div>
            <div>
              <h2>10. Hinweis zu Kindern und Jugendlichen</h2>
              Diese Anwendung richtet sich nicht an Personen unter 16 Jahren. Sollten Daten von Minderjährigen
              übermittelt
              werden, werden diese gelöscht, sofern keine Einwilligung der Eltern vorliegt oder ein Versicherungsfall
              dies
              rechtfertigt.
            </div>
            <div>
              <h2>11. Hinweise zu Dritten und Zeug:innen</h2>
              Sofern du Angaben zu weiteren Beteiligten oder Zeug:innen machst (z. B. Name, Rolle, Beschreibung des
              Vorfalls),
              bist du verpflichtet, sicherzustellen, dass diese Personen über die Datenverarbeitung informiert sind. Wir
              weisen darauf hin, dass diese Personen – sofern uns ihre Kontaktdaten vorliegen – automatisch durch uns
              oder
              den
              Versicherer informiert werden.
            </div>
            <div>
              <h2>12. Rechte der betroffenen Personen</h2>
              Du hast nach der Datenschutz-Grundverordnung (DSGVO) verschiedene Rechte, die du jederzeit geltend machen
              kannst. Im Einzelnen sind das:
              <ul>
                <li>
                  <b>Auskunft (Art. 15 DSGVO):</b>
                  Du hast das Recht, Auskunft darüber zu verlangen, ob personenbezogene Daten über dich verarbeitet
                  werden.
                  Ist
                  dies der Fall, kannst du insbesondere Informationen über die Verarbeitungszwecke, die Kategorien der
                  personenbezogenen Daten, die Empfänger oder Kategorien von Empfängern, die geplante Speicherdauer oder
                  die
                  Kriterien für deren Festlegung, das Bestehen deiner Rechte sowie die Herkunft der Daten (sofern sie
                  nicht
                  direkt
                  bei dir erhoben wurden) verlangen.
                </li>
                <li>
                  <b>Berichtigung (Art. 16 DSGVO):</b>
                  Du hast das Recht, unverzüglich die Berichtigung dich betreffender unrichtiger personenbezogener Daten
                  zu
                  verlangen. Unter Berücksichtigung des Zwecks der Verarbeitung hast du außerdem das Recht, die
                  Vervollständigung
                  unvollständiger personenbezogener Daten zu verlangen.
                </li>
                <li>
                  <b>Löschung (Art. 17 DSGVO):</b>
                  Du hast das Recht, die unverzügliche Löschung deiner personenbezogenen Daten zu verlangen, sofern eine
                  der
                  folgenden Voraussetzungen vorliegt:
                  – Die Daten sind für die Zwecke, für die sie erhoben oder verarbeitet wurden, nicht mehr notwendig.
                  – Du widerrufst deine Einwilligung und es fehlt an einer anderweitigen Rechtsgrundlage.
                  – Du legst Widerspruch ein (siehe unten) und es liegen keine vorrangigen berechtigten Gründe für die
                  Verarbeitung vor.
                  – Die Daten wurden unrechtmäßig verarbeitet.
                  – Die Löschung ist zur Erfüllung einer rechtlichen Verpflichtung erforderlich.
                  Dieses Recht gilt nicht, wenn gesetzliche Aufbewahrungspflichten entgegenstehen.
                  Einschränkung der Verarbeitung (Art. 18 DSGVO):
                  Du hast das Recht, die Einschränkung der Verarbeitung zu verlangen, wenn eine der folgenden
                  Voraussetzungen
                  vorliegt:
                  – Du bestreitest die Richtigkeit der Daten (für die Dauer der Überprüfung).
                  – Die Verarbeitung ist unrechtmäßig und du verlangst statt der Löschung die Einschränkung.
                  – Die Daten werden nicht mehr benötigt, du benötigst sie jedoch zur Geltendmachung, Ausübung oder
                  Verteidigung
                  von Rechtsansprüchen.
                  – Du hast Widerspruch eingelegt (solange noch nicht feststeht, ob unsere berechtigten Gründe
                  überwiegen).
                </li>
                <li>
                  <b>Datenübertragbarkeit (Art. 20 DSGVO):</b>
                  Du hast das Recht, personenbezogene Daten, die du uns bereitgestellt hast, in einem strukturierten,
                  gängigen
                  und
                  maschinenlesbaren Format zu erhalten. Du hast außerdem das Recht, diese Daten einem anderen
                  Verantwortlichen
                  zu
                  übermitteln, sofern die Verarbeitung auf deiner Einwilligung oder auf einem Vertrag beruht und
                  mithilfe
                  automatisierter Verfahren erfolgt.
                </li>
                <li><b>Widerspruch (Art. 21 DSGVO):</b>
                  Du hast das Recht, aus Gründen, die sich aus deiner besonderen Situation ergeben, jederzeit gegen die
                  Verarbeitung deiner personenbezogenen Daten Widerspruch einzulegen, wenn die Verarbeitung auf
                  berechtigtem
                  Interesse beruht. In diesem Fall werden deine Daten nicht mehr verarbeitet, es sei denn, wir können
                  zwingende
                  schutzwürdige Gründe nachweisen, die deine Interessen, Rechte und Freiheiten überwiegen oder die
                  Verarbeitung
                  dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
                </li>
              </ul>
              Bitte wende dich hierzu an: <a href="mailto:kontakt@klrm.berlin">kontakt&#64;klrm.berlin</a>
            </div>
            <div>
              <h2>13. Beschwerderecht bei Aufsichtsbehörden</h2>
              Wenn du der Auffassung bist, dass deine Daten unrechtmäßig verarbeitet werden, hast du das Recht, dich bei
              einer
              Datenschutzaufsichtsbehörde zu beschweren. Zuständig ist insbesondere die Aufsichtsbehörde deines:
              <ul>
                <li>Aufenthaltsortes</li>
                <li>Arbeitsplatzes</li>
                <li>Orts des mutmaßlichen Verstoßes</li>
              </ul>
              In Deutschland z. B. die:<br>
              <div style="margin-top: 8px; margin-bottom: 8px;"><b>Berliner Beauftragte für Datenschutz und
                Informationsfreiheit</b><br></div>
              <div style="margin-top: 8px; margin-bottom: 8px;">Alt-Moabit 59-61, 10555 Berlin</div>
              <a href="https://www.datenschutz-berlin.de" target="_blank">www.datenschutz-berlin.de</a>
            </div>
            <div>
              Stand: Juni 2025
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 0 22px 14px 22px">
        <app-footer/>
      </div>
    </div>
